module.exports = __webpack_public_path__ + "static/media/brainflix-macbook-comments.92103927.jpg";